export default __webpack_public_path__ + "static/media/bkg--home-3.d903f4ae.jpg";